export enum CollectionStatusEnum {
	WAITING_COLLECTION = 'WAITING_COLLECTION',
	WAITING_IMPORT = 'WAITING_IMPORT',
	NOT_COLLECTED = 'NOT_COLLECTED',
	DRY_POINT = 'DRY_POINT',
	IMPORTED = 'IMPORTED',
}

export enum CollectionStatusLabelEnum {
	WAITING_COLLECTION = 'Aguardando Coleta',
	WAITING_IMPORT = 'Aguardando Importação',
	NOT_COLLECTED = 'Não Coletada',
	DRY_POINT = 'Ponto Seco',
	IMPORTED = 'Importada',
}
